/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Row_Most_UsedInputs */

const en_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most used`)
};

const zh_hans1_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最常用`)
};

const pt_br2_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais usado`)
};

const es_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más usado`)
};

const fr_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les plus utilisés`)
};

const de_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistgenutzt`)
};

const ru_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые используемые`)
};

const it_platform_row_most_used = /** @type {(inputs: Platform_Row_Most_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più usato`)
};

/**
* | output |
* | --- |
* | "Most used" |
*
* @param {Platform_Row_Most_UsedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_row_most_used = /** @type {((inputs?: Platform_Row_Most_UsedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Row_Most_UsedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_row_most_used(inputs)
	if (locale === "pt-BR") return pt_br2_platform_row_most_used(inputs)
	if (locale === "es") return es_platform_row_most_used(inputs)
	if (locale === "fr") return fr_platform_row_most_used(inputs)
	if (locale === "de") return de_platform_row_most_used(inputs)
	if (locale === "ru") return ru_platform_row_most_used(inputs)
	if (locale === "it") return it_platform_row_most_used(inputs)
	return en_platform_row_most_used(inputs)
});